import Navbar from "../../../components/Navbar/Navbar";
import PracticePrescriptionNotificationsView from "../components/PracticePrescriptionNotificationsView/PracticePrescriptionNotificationsView";

export default function PracticePrescriptionNotificationsPage() {
    return (
        <>
            <Navbar title="Pharmacy Messages" />
            <div className="page">
                <PracticePrescriptionNotificationsView />
            </div>
        </>
    );
}
